import h from "../helpers";
import copy from "copy-to-clipboard";
import { setVar, setVarPersist } from "./actionCreators";
import {
    flowRelatedRequestStart,
    flowRelatedRequestCompleted,
    treeRequestStart,
    treeRequestCompleted,
} from "./loadingActions";
import { ToggleIsLayoutTreeLoading } from "./treeBehaviorActions";
import { IScriptObject, ILoadScriptObjects, ILoadUIDBScriptObjects } from "../types/stores/vars";
import { request } from "../helpers/httpInterceptor";
import {
    FieldRateByFieldId,
    TaxmanFieldRateByFieldId,
    FieldDistributionCountsById,
    LoadEnabledFieldLabelsAction,
    LoadEnabledFieldLabelsAction3,
    LoadEnabledFieldVisibilityTypesAction,
    LoadFieldRatesAction,
    ToggleIsFieldTreeLoadingAction,
    LoadTaxmanFieldRatesAction,
    LoadFieldDistributionCountsAction,
    LOAD_FIELD_RATES,
    LOAD_TAXMAN_FIELD_RATES,
    LOAD_DISTRIBUTION_COUNTS,
    TOGGLE_IS_FIELD_TREE_LOADING,
} from "../types/stores/fieldsByCompany";

if (!top.RDX) {
    top.RDX = {};
}

let _fieldsLastLoadedByTable = {};
let _haveTablesChanged = true;
let _lastTablesChangedDate = Date.parse("2000-01-25T10:18:18Z");

export const requestScriptObjects = scriptType => dispatch => {
    let url = `/Scripts/GetFullScriptAccess?scriptType=${scriptType}`;
    dispatch(incAjaxCount());
    dispatch(flowRelatedRequestStart());
    dispatch(treeRequestStart());
    dispatch(ToggleIsLayoutTreeLoading(true));
    return request(
        url,
        {
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
        },
        dispatch
    )
        .then(h.checkStatus)
        .then(h.toJson)
        .then(data => {
            dispatch(decAjaxCount());
            dispatch(flowRelatedRequestCompleted());
            dispatch(treeRequestCompleted());
            dispatch(ToggleIsLayoutTreeLoading(false));

            if (data.results) {
                if (scriptType == 0) {
                    dispatch(loadScriptObjects(data.results));
                } else {
                    dispatch(loadUIDBScriptObjects(data.results));
                }
            } else {
                throw new Error("Couldn't load script objects.");
            }

            //TODO123 checksum work
            // if (data.checksum) {
            //     dispatch(setVarPersist("scriptObjsChecksum", data.checksum));
            // } else {
            //     throw new Error("Couldn't load script objects checksum.");
            // }
        })
        .catch(error => {
            dispatch(decAjaxCount());
            dispatch(flowRelatedRequestCompleted());
            dispatch(treeRequestCompleted());
            dispatch(ToggleIsLayoutTreeLoading(false));

            h.error("Error loading script objects.", error);
        });
};
top.RDX.requestScriptObjects = () => top.store.dispatch(requestScriptObjects());

export const searchColumns = filter => dispatch => {
    let url = `/Scripts/SearchColumns/${filter}`;

    dispatch(incAjaxCount());
    dispatch(flowRelatedRequestStart());
    dispatch(treeRequestStart());
    dispatch(ToggleIsLayoutTreeLoading(true));

    return request(
        url,
        {
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
        },
        dispatch
    )
        .then(h.checkStatus)
        .then(h.toJson)
        .then(data => {
            dispatch(decAjaxCount());
            dispatch(flowRelatedRequestCompleted());
            dispatch(treeRequestCompleted());
            dispatch(ToggleIsLayoutTreeLoading(false));

            if (data.columns) {
                dispatch(loadScriptObjects(data.columns));
            } else {
                throw new Error("Couldn't load script objects.");
            }
        })
        .catch(error => {
            dispatch(decAjaxCount());
            dispatch(flowRelatedRequestCompleted());
            dispatch(treeRequestCompleted());
            dispatch(ToggleIsLayoutTreeLoading(false));

            h.error("Error loading script objects.", error);
        });
};
top.RDX.searchColumns = () => top.store.dispatch(searchColumns());

export const requestAudienceCounts = companyId => dispatch => {
    let url = "/api/audiencecounts/GetAudienceCounts?companyId=" + companyId;
    return request(url, { credentials: "same-origin" }, dispatch)
        .then(h.checkStatus)
        .then(h.toJson)
        .then(data => {
            if (data.audiencecounts) {
                dispatch(loadFieldDistributionCounts(data.audiencecounts));
            } else {
                throw new Error("Couldn't load Audience Counts.");
            }
        })
        .catch(error => {
            h.error("Error loading Audience Counts.", error);
        });
};
top.RDX.requestAudienceCounts = companyId => top.store.dispatch(requestAudienceCounts(companyId));

export const requestFieldTreeLastUpdated = () => async dispatch => {
    let urlDates = "/Tree/FieldTablesLastUpdated";
    try {
        const response = await request(urlDates, { credentials: "same-origin" }, dispatch);
        const response1 = await h.checkStatus(response);
        const data = await h.toJson(response1);
        if (data) {
            let highestDate = Date.parse(data[0].DateUpdated);
            if (highestDate > _lastTablesChangedDate) {
                _lastTablesChangedDate = highestDate;
                _haveTablesChanged = true;
            } else {
                _haveTablesChanged = false;
            }
        }
    } catch (error) {
        h.error("Error loading field tree Last Updated.", error);
    }
};
top.RDX.requestFieldTreeLastUpdated = tableKey => top.store.dispatch(requestFieldTreeLastUpdated(tableKey));

// tableKey - an optional tableKey to load fields for
export const requestFieldTree =
    (tableKey, dontRequestAgainMinutes = 0, isScriptNode = false) =>
    async (dispatch, getState) => {
        if (getState().fieldsByCompany.isFieldTreeLoading) {
            return;
        }
        dispatch(toggleIsFieldTreeLoading(true));

        try {
            const state = getState();
            const features = state.session.enabledFeatures || [];

            // Check if lazy loading is enabled
            const useLazyLoading = features.includes("lazy-loading-fieldtree");
            if (useLazyLoading && !isScriptNode) {
                // Redirect to lazy loading implementation
                return dispatch(requestLazyFieldTree());
            }

            const enhancedFiledLoading = features.includes("use-enhanced-field-loading");
            const useFieldTreeTabs = features.includes("field-tree-tabs");
            if (enhancedFiledLoading) {
                await dispatch(requestFieldTreeLastUpdated());
                if (!_haveTablesChanged) {
                    dispatch(toggleIsFieldTreeLoading(false));
                    return;
                }
            }
            let url = "/Tree/Combined";
            if (tableKey) {
                url += "/" + tableKey;
            }
            tableKey = tableKey || 0;
            const lastLoadedTableKey = state.vars.fieldTreeLastTableKeyLoaded || 0;
            const companyId = getState().session.companyId;

            // Optional Parameter:  If dontRequestAgainMinutes = 5, then don't do any requests if we
            // asked for the field tree in the last five minutes.
            // Also, if table key is changing, then ignore this.
            const localCachedValueExists =
                _fieldsLastLoadedByTable[tableKey] != null &&
                dateDiffMinutes(_fieldsLastLoadedByTable[tableKey], new Date()) < dontRequestAgainMinutes;
            const tableKeyChanged = tableKey != lastLoadedTableKey;
            if (!tableKeyChanged && localCachedValueExists) {
                return;
            }
            _fieldsLastLoadedByTable[tableKey] = new Date();

            dispatch(incAjaxCount());
            dispatch(flowRelatedRequestStart());
            dispatch(treeRequestStart());
            dispatch(ToggleIsLayoutTreeLoading(true));
            return request(url, { credentials: "same-origin" }, dispatch)
                .then(h.checkStatus)
                .then(h.toJson)
                .then(data => {
                    dispatch(decAjaxCount());
                    dispatch(flowRelatedRequestCompleted());
                    dispatch(treeRequestCompleted());
                    dispatch(ToggleIsLayoutTreeLoading(false));

                    if (data.fields) {
                        dispatch(loadFields(data.fields, tableKey));
                        if (useFieldTreeTabs) {
                            dispatch(setTreeTabs(data.fieldsExperian, data.fieldsMarketplace, data.fieldsMyData));
                        }
                        if (data.enabledFieldLabels) {
                            dispatch(loadEnabledFieldLabels(data.enabledFieldLabels));
                        }
                        if (data.enabledFieldLabels3) {
                            dispatch(loadEnabledFieldLabels3(data.enabledFieldLabels3));
                        }
                        if (data.enabledFieldVisibilityTypes) {
                            dispatch(loadEnabledFieldVisibilityTypes(data.enabledFieldVisibilityTypes));
                        }
                        if (data.visibleFieldByCompanyUsers) {
                            dispatch(loadVisibilityByCompanyUsers(data.visibleFieldByCompanyUsers));
                        }
                        if (data.fieldRates) {
                            dispatch(loadFieldRates(data.fieldRates));
                        }
                        if (data.taxmanFieldRates) {
                            dispatch(loadTaxmanFieldRates(data.taxmanFieldRates));
                        }

                        dispatch(requestAudienceCounts(companyId));
                        
                    } else {
                        throw new Error("Couldn't load fields.");
                    }
                    if (data.checksum) {
                        dispatch(setVarPersist("fieldsChecksum", data.checksum));
                    } else {
                        throw new Error("Couldn't load fields checksum.");
                    }
                })
                .catch(error => {
                    dispatch(decAjaxCount());
                    dispatch(flowRelatedRequestCompleted());
                    dispatch(treeRequestCompleted());
                    dispatch(ToggleIsLayoutTreeLoading(false));

                    h.error("Error loading field tree.", error);
                });
        } finally {
            dispatch(toggleIsFieldTreeLoading(false));
        }
    };
top.RDX.requestFieldTree = tableKey => top.store.dispatch(requestFieldTree(tableKey));

export const requestCompanyFieldTree = companyId => dispatch => {
    let url = "/Tree/CompanyCombined/" + companyId;
    dispatch(incAjaxCount());
    dispatch(treeRequestStart());

    return request(url, { credentials: "same-origin" }, dispatch)
        .then(h.checkStatus)
        .then(h.toJson)
        .then(data => {
            dispatch(decAjaxCount());
            dispatch(treeRequestCompleted());

            if (data.fields) {
                dispatch(loadFields(data.fields, 0));
                if (data.enabledFieldLabels) {
                    dispatch(loadEnabledFieldLabels(data.enabledFieldLabels));
                }
                if (data.enabledFieldLabels3) {
                    dispatch(loadEnabledFieldLabels3(data.enabledFieldLabels3));
                }
                if (data.enabledFieldVisibilityTypes) {
                    dispatch(loadEnabledFieldVisibilityTypes(data.enabledFieldVisibilityTypes));
                }
                if (data.visibleFieldByCompanyUsers) {
                    dispatch(loadVisibilityByCompanyUsers(data.visibleFieldByCompanyUsers));
                }
                if (data.fieldRates) {
                    dispatch(loadFieldRates(data.fieldRates));
                }
                if (data.taxmanFieldRates) {
                    dispatch(loadTaxmanFieldRates(data.taxmanFieldRates));
                }
            } else {
                throw new Error("Couldn't load fields.");
            }
        })
        .catch(error => {
            dispatch(decAjaxCount());
            dispatch(treeRequestCompleted());

            h.error("Error loading company field tree.", error);
        });
};

export const requestLazyFieldTree = (isAdmin = false) => async (dispatch, getState) => {
    try {
        const state = getState();
        const companyId = state.session.companyId;
        const features = state.session.enabledFeatures || [];
        const useFieldTreeTabs = features.includes("field-tree-tabs");

        dispatch(incAjaxCount());
        dispatch(flowRelatedRequestStart());
        dispatch(treeRequestStart());
        dispatch(ToggleIsLayoutTreeLoading(true));

        // Fetch top-level folders and tree metadata in parallel
        const [childrenResponse, detailsResponse] = await Promise.all([
            request(`/Tree/children?editFields=${isAdmin ? 1 : 0}`, { credentials: "same-origin" }, dispatch),
            request(`/Tree/treedetails?editFields=${isAdmin ? 1 : 0}`, { credentials: "same-origin" }, dispatch),
        ]);

        const [data, details] = await Promise.all([
            h.toJson(await h.checkStatus(childrenResponse)),
            h.toJson(await h.checkStatus(detailsResponse)),
        ]);

        dispatch(decAjaxCount());
        dispatch(flowRelatedRequestCompleted());
        dispatch(treeRequestCompleted());
        dispatch(ToggleIsLayoutTreeLoading(false));

        if (data.fields) {
            // Load the top-level fields
            dispatch(loadOrMergeFields(data.fields, 0));

            const updatedState = getState();
            dispatch(cacheFieldsForMode(updatedState.fields, isAdmin));
            if (useFieldTreeTabs) {
                dispatch(setTreeTabs(data.fieldsExperian, data.fieldsMarketplace, data.fieldsMyData));
            }
            // Mark root as loaded
            dispatch(markFolderAsLoaded("#"));

            // Optionally load audience counts
            dispatch(requestAudienceCounts(companyId));
        } else {
            throw new Error("Couldn't load fields.");
        }

        // Dispatch metadata from TreeDetails (mirrors what requestFieldTree does, without fields)
        if (details.enabledFieldLabels) {
            dispatch(loadEnabledFieldLabels(details.enabledFieldLabels));
        }
        if (details.enabledFieldLabels3) {
            dispatch(loadEnabledFieldLabels3(details.enabledFieldLabels3));
        }
        if (details.enabledFieldVisibilityTypes) {
            dispatch(loadEnabledFieldVisibilityTypes(details.enabledFieldVisibilityTypes));
        }
        if (details.visibleFieldByCompanyUser) {
            dispatch(loadVisibilityByCompanyUsers(details.visibleFieldByCompanyUser));
        }
        if (details.fieldRates) {
            dispatch(loadFieldRates(details.fieldRates));
        }
        if (details.taxmanFieldRates) {
            dispatch(loadTaxmanFieldRates(details.taxmanFieldRates));
        }
        if (details.checksum) {
            dispatch(setVarPersist("fieldsChecksum", details.checksum));
        }
    } catch (error) {
        dispatch(decAjaxCount());
        dispatch(flowRelatedRequestCompleted());
        dispatch(treeRequestCompleted());
        dispatch(ToggleIsLayoutTreeLoading(false));
        h.error("Error loading lazy field tree.", error);
    } finally {
        dispatch(toggleIsFieldTreeLoading(false));
    }
};
top.RDX.requestLazyFieldTree = (isAdmin = false) => top.store.dispatch(requestLazyFieldTree(isAdmin));

export const requestLazyChildFields = (folderId, onComplete, editFields = false) => async (dispatch, getState) => {   
    const state = getState();

    // Check if already loaded
    const loadedFolders = state.vars?.loadedFolders || {};
    const byParent = state.fields?.byParent || {};
    const existingChildren = byParent[folderId];
    
    if (!editFields && loadedFolders[folderId] && existingChildren && existingChildren.length > 0) {
        return;
    }

    // SET LOADING STATE BEFORE REQUEST
    dispatch(setFolderLoading(folderId, true));

    const url = `/Tree/children/${folderId}`;

    dispatch(incAjaxCount());

    try {
        const response = await request(url, { credentials: "same-origin" }, dispatch);
        const data = await h.toJson(await h.checkStatus(response));
        dispatch(decAjaxCount());


        if (data.fields) {
            // Merge the new children into existing fields
            dispatch(mergeChildFields(data.fields, folderId));
            
            // Mark folder as loaded
            dispatch(markFolderAsLoaded(folderId));
            
            // CLEAR LOADING STATE AFTER SUCCESS
            dispatch(setFolderLoading(folderId, false));

            const updatedState = getState();
            dispatch(cacheFieldsForMode(updatedState.fields, editFields));

            // Call the callback if provided
            if (onComplete) {
                onComplete();
            }
        } else {
            throw new Error("Couldn't load child fields.");
        }
    } catch (error) {
        dispatch(decAjaxCount());
        dispatch(setFolderLoading(folderId, false));        
        h.error("Error loading child fields.", error);
    }
};
top.RDX.requestLazyChildFields = (folderId, onComplete, editFields) => top.store.dispatch(requestLazyChildFields(folderId, onComplete, editFields));


export const requestFieldAncestors = (fieldId, onComplete) => async (dispatch, getState) => {
    const state = getState();
    const editFields = state.vars?.prevEditable ? 1 : 0;
    const url = `/Tree/ancestors/${fieldId}?editFields=${editFields}`;

    dispatch(incAjaxCount());

    try {
        const response = await request(url, { credentials: "same-origin" }, dispatch);
        const data = await h.toJson(await h.checkStatus(response));

        dispatch(decAjaxCount());

        if (data.ancestors) {
            // Call the callback if provided with the ancestors data
            if (onComplete) {
                onComplete(data.ancestors);
            }
            
            return data.ancestors;
        } else {
            throw new Error("Couldn't load field ancestors.");
        }
    } catch (error) {
        dispatch(decAjaxCount());
        h.error("Error loading field ancestors.", error);
        return null;
    }
};
top.RDX.requestFieldAncestors = (fieldId, onComplete) => top.store.dispatch(requestFieldAncestors(fieldId, onComplete));

export const requestFieldDetails = (fieldId, onComplete) => async (dispatch, getState) => {

    dispatch(incAjaxCount());
    const state = getState();
    const editFields = state.vars?.prevEditable ? 1 : 0;
    const url = `/Tree/details/${fieldId}?editFields=${editFields}`;

    dispatch(incAjaxCount());
    try {
        const response = await request(url, { credentials: "same-origin" }, dispatch);
        const data = await h.toJson(await h.checkStatus(response));
        
        dispatch(decAjaxCount());

        // Early return if data is null
        if (!data) {
            return null;
        }

        // Call the callback if provided with the field details
        if (onComplete) {
            onComplete(data);
        }
        
        return data;
    } catch (error) {
        dispatch(decAjaxCount());
        h.error("Error loading field details.", error);
        return null;
    }
};
top.RDX.requestFieldDetails = (fieldId, onComplete) => top.store.dispatch(requestFieldDetails(fieldId, onComplete));


export const requestFlowFieldInformation = (flowId) => async (dispatch, getState) => {
    if (!flowId) {
        return;
    }

    const url = `/Tree/flowfields/${flowId}`;
    dispatch(incAjaxCount());

    try {
        const response = await request(url, { credentials: "same-origin" }, dispatch);
        const data = await h.toJson(await h.checkStatus(response));
        dispatch(decAjaxCount());

      if (data.fields) {
            dispatch(mergeChildFields(data.fields, 0));
            const updatedState = getState();
            dispatch(cacheFieldsForMode(updatedState.fields, false));

        } else {
            throw new Error("Couldn't load child fields.");
        }
    } catch (error) {
        dispatch(decAjaxCount());
        h.error("Error loading flow field information.", error);
    }
};
top.RDX.requestFlowFieldInformation = (flowId) => top.store.dispatch(requestFlowFieldInformation(flowId));

export const preloadFieldTree = (tableKey = 0) => async (dispatch, getState) => {
    const state = getState();
    const editFields = state.vars?.prevEditable ? 1 : 0;
    const url = `/Tree/PreloadFieldTree${tableKey ? `/${tableKey}` : ""}?editFields=${editFields}`;

    try {
        const response = await request(url, { credentials: "same-origin" }, dispatch);
        await h.checkStatus(response);
    } catch (error) {
        h.error("Error preloading field tree.", error);
    }
};
top.RDX.preloadFieldTree = (tableKey) => top.store.dispatch(preloadFieldTree(tableKey));

// Action to merge child fields without replacing the entire tree
export const mergeChildFields = (childFields, parentId) => ({
    type: "MERGE_CHILD_FIELDS",
    childFields,
    parentId,
});

// Action to track which folders have been loaded
export const markFolderAsLoaded = (folderId) => ({
    type: "MARK_FOLDER_AS_LOADED",
    folderId,
});

// Add this action creator
export const clearLoadedFolders = () => ({
    type: "CLEAR_LOADED_FOLDERS",
});
export const setFolderLoading = (folderId, isLoading) => ({
    type: "SET_FOLDER_LOADING",
    folderId,
    isLoading,
});

export const toggleExpandFolder = (folderId: string | number) => ({
    type: "TOGGLE_EXPAND_FOLDER",
    folderId
})

export const switchToViewModeCache = () => (dispatch, getState) => {
    const state = getState();
    const cachedFields = state.vars.fieldsView;
    dispatch(clearExpandedFolders());
    if (!cachedFields) {
        dispatch({ type: "CLEAR_FIELDS_FOR_MODE_SWITCH" });
    }
    dispatch({ 
        type: "SWITCH_TO_VIEW_MODE_CACHE",
        cachedFields,
    });
};

export const switchToEditModeCache = () => (dispatch, getState) => {
    const state = getState();
    const cachedFields = state.vars.fieldsEdit;
    dispatch(clearExpandedFolders());
    if (!cachedFields) {
        dispatch({ type: "CLEAR_FIELDS_FOR_MODE_SWITCH" });
    }
    dispatch({ 
        type: "SWITCH_TO_EDIT_MODE_CACHE", 
        cachedFields 
    });

};

top.RDX.switchToViewModeCache = () => top.store.dispatch(switchToViewModeCache());
top.RDX.switchToEditModeCache = () => top.store.dispatch(switchToEditModeCache());

export const cacheFieldsForMode = (fields, isEditMode) => ({
    type: "CACHE_FIELDS_FOR_MODE",
    fields,
    isEditMode,
});

export const clearExpandedFolders = () => ({
    type: "CLEAR_EXPANDED_FOLDERS",
})
// This is a way to use requestFieldTree(), but if we don't know which tableKey we 'should'
// be looking at, we will use the last tableKey that was used for a fieldTree request
// example:
//    User selects a table with <TablePicker> - and we load fields for TableKey = 39
//    Server needs to tell the client to update Fields, but it can't run requestFieldTree,
//       because that would load fields for TableKey = 0.
//    Server calls this instead, which finds TableKey=39 in the state, automatically set by
//    the vars reducer, and updates fields for tablekey=39.
export const requestFieldTreeForLastTablekeyUsed = () => (dispatch, getState) => {
    const state = getState();
    const tableKey = state.vars.fieldTreeLastTableKeyLoaded || 0;
    dispatch(requestFieldTree(tableKey));
};
top.RDX.requestFieldTreeForLastTablekeyUsed = () => top.store.dispatch(requestFieldTreeForLastTablekeyUsed());

export const requestFieldTreeSetTableImmediately = tableKey => dispatch => {
    dispatch(setTableKey(tableKey)); //Setting immediately prevents Tree/Combined from being called multiple times from CreateFlowApp
    dispatch(requestFieldTree(tableKey));
};
top.RDX.requestFieldTreeSetTableImmediately = tableKey =>
    top.store.dispatch(requestFieldTreeSetTableImmediately(tableKey));

// Special version of Tree for Edit Fields page
export const requestEditFieldTree =
    (isBulkAction = 0) =>
    (dispatch, getState) => {
        const url = `/Tree/Combined?editFields=1&isBulkAction=${isBulkAction}`;
        const state = getState();
        const features = state.session.enabledFeatures || [];
        const useLazyLoading = features.includes("lazy-loading-fieldtree");
        
        // Redirect to lazy loading implementation if enabled and not bulk action
        if (useLazyLoading && isBulkAction === 0) {
            return dispatch(requestLazyFieldTreeAdmin(true));
        }
        const useFieldTreeTabs = features.includes("field-tree-tabs");
        dispatch(incAjaxCount());
        return (
            request(url, { credentials: "same-origin" }, dispatch)
                /* eslint-disable no-console */
                .then(h.checkStatus)
                .then(console.log("Tree/Combined:checkStatus" + Date().toLocaleString() + ""))
                .then(h.toJson)
                .then(console.log("Tree/Combined:toJson" + Date().toLocaleString() + ""))
                .then(data => {
                    dispatch(decAjaxCount());
                    if (data.fields) {
                        dispatch(loadFields(data.fields, 0));
                        if (useFieldTreeTabs) {
                            dispatch(
                                setTreeTabs(
                                    data.fieldsExperian,
                                    data.fieldsMarketplace,
                                    data.fieldsMyData,
                                    data.fieldsOther
                                )
                            );
                        }
                        if (data.enabledFieldLabels) {
                            dispatch(loadEnabledFieldLabels(data.enabledFieldLabels));
                        }
                        if (data.enabledFieldVisibilityTypes) {
                            dispatch(loadEnabledFieldVisibilityTypes(data.enabledFieldVisibilityTypes));
                        }
                        if (data.visibleFieldByCompanyUsers) {
                            dispatch(loadVisibilityByCompanyUsers(data.visibleFieldByCompanyUsers));
                        }
                        if (isBulkAction == 0) {
                            if (data.enabledFieldLabels3) {
                                dispatch(loadEnabledFieldLabels3(data.enabledFieldLabels3));
                            }
                            if (data.fieldRates) {
                                dispatch(loadFieldRates(data.fieldRates));
                            }
                            if (data.taxmanFieldRates) {
                                dispatch(loadTaxmanFieldRates(data.taxmanFieldRates));
                            }
                        }
                    } else {
                        throw new Error("Couldn't load fields.");
                    }
                })
                .catch(error => {
                    h.error("Error loading field tree.", error);
                    dispatch(decAjaxCount());
                })
        );
    };
top.RDX.requestEditFieldTree = () => top.store.dispatch(requestEditFieldTree());

export const requestEditLayoutFieldTree = () => dispatch => {
    const url = "/Tree/LayoutCombined?editFields=1";
    return (
        request(url, { credentials: "same-origin" }, dispatch)
            /* eslint-disable no-console */
            .then(h.checkStatus)
            .then(console.log("LayoutCombined:checkStatus" + Date().toLocaleString() + ""))
            .then(h.toJson)
            .then(console.log("LayoutCombined:toJson" + Date().toLocaleString() + ""))
            .then(data => {
                if (data.fields) {
                    dispatch(loadLayoutFields(data.fields));
                } else {
                    throw new Error("Couldn't layout load fields.");
                }
                if (data.enabledFieldVisibilityTypes) {
                    dispatch(loadEnabledFieldVisibilityTypes(data.enabledFieldVisibilityTypes));
                }
            })
            .catch(error => {
                h.error("Error loading layout field tree.", error);
            })
    );
};
top.RDX.requestEditLayoutFieldTree = () => top.store.dispatch(requestEditLayoutFieldTree());

export const requestEditReportFieldTree = () => dispatch => {
    const url = "/Tree/ReportCombined?editFields=1";
    return request(url, { credentials: "same-origin" }, dispatch)
        .then(h.checkStatus)
        .then(h.toJson)
        .then(data => {
            if (data.fields) {
                dispatch(loadReportFields(data.fields));
            } else {
                throw new Error("Couldn't report load fields.");
            }
            if (data.enabledFieldVisibilityTypes) {
                dispatch(loadEnabledFieldVisibilityTypes(data.enabledFieldVisibilityTypes));
            }
            if (data.fieldRates) {
                dispatch(loadFieldRates(data.fieldRates));
            }
            if (data.taxmanFieldRates) {
                dispatch(loadTaxmanFieldRates(data.taxmanFieldRates));
            }
        })
        .catch(error => {
            h.error("Error loading report field tree.", error);
        });
};
top.RDX.requestEditReportFieldTree = () => top.store.dispatch(requestEditReportFieldTree());

export const requestEnabledFieldCompanies = () => dispatch => {
    const url = "/Field/GetEnabledFieldCompanies";
    dispatch(incAjaxCount());
    return request(
        url,
        {
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
        },
        dispatch
    )
        .then(h.checkStatus)
        .then(h.toJson)
        .then(data => {
            dispatch(loadEnabledFieldCompanies(data.fieldCompanies));
            dispatch(decAjaxCount());
        })
        .catch(error => {
            h.error("Error loading field companies.", error);
            dispatch(decAjaxCount());
        });
};

export const loadEnabledFieldLabels = (enabledFieldLabels): LoadEnabledFieldLabelsAction => ({
    type: "LOAD_ENABLED_FIELD_LABELS",
    enabledFieldLabels,
});

export const loadEnabledFieldLabels3 = (enabledFieldLabels3): LoadEnabledFieldLabelsAction3 => ({
    type: "LOAD_ENABLED_FIELD_LABELS3",
    enabledFieldLabels3,
});

export const loadEnabledFieldVisibilityTypes = (
    enabledFieldVisibilityTypes
): LoadEnabledFieldVisibilityTypesAction => ({
    type: "LOAD_ENABLED_FIELD_VISIBILITY_TYPES",
    enabledFieldVisibilityTypes,
});

export const toggleIsFieldTreeLoading = (isFieldTreeLoading: boolean): ToggleIsFieldTreeLoadingAction => ({
    type: TOGGLE_IS_FIELD_TREE_LOADING,
    isFieldTreeLoading,
});

export const loadEnabledFieldCompanies = enabledFieldCompanies => ({
    type: "LOAD_ENABLED_FIELD_COMPANIES",
    enabledFieldCompanies,
});

export const loadVisibilityByCompanyUsers = visibilityByCompanyUsers => ({
    type: "LOAD_VISIBILITY_COMPANY_USERS",
    visibilityByCompanyUsers,
});

export const loadFieldRates = (fieldRates: FieldRateByFieldId): LoadFieldRatesAction => ({
    type: LOAD_FIELD_RATES,
    fieldRates,
});

export const loadTaxmanFieldRates = (taxmanFieldRates: TaxmanFieldRateByFieldId): LoadTaxmanFieldRatesAction => ({
    type: LOAD_TAXMAN_FIELD_RATES,
    taxmanFieldRates,
});

export const loadFieldDistributionCounts = (
    fieldDistributionCounts: FieldDistributionCountsById
): LoadFieldDistributionCountsAction => ({
    type: LOAD_DISTRIBUTION_COUNTS,
    fieldDistributionCounts,
});

export const setTableKey = (tableKey = 0) => ({
    type: "SET_LAST_TABLEKEY",
    tableKey,
});
top.RDX.setTableKey = tableKey => top.store.dispatch(setTableKey(tableKey));

export const requestLazyFieldTreeAdmin = (forceReload = false) => async (dispatch, getState) => {

    try {
        const state = getState();
        const features = state.session.enabledFeatures || [];
        const useFieldTreeTabs = features.includes("field-tree-tabs");

        dispatch(incAjaxCount());
        dispatch(flowRelatedRequestStart());
        dispatch(treeRequestStart());
        dispatch(ToggleIsLayoutTreeLoading(true));

        // Fetch top-level folders and tree metadata in parallel
        const [childrenResponse, detailsResponse] = await Promise.all([
            request("/Tree/children?editFields=1", { credentials: "same-origin" }, dispatch),
            request("/Tree/treedetails?editFields=1", { credentials: "same-origin" }, dispatch),
        ]);

        const [data, details] = await Promise.all([
            h.toJson(await h.checkStatus(childrenResponse)),
            h.toJson(await h.checkStatus(detailsResponse)),
        ]);

        dispatch(decAjaxCount());
        dispatch(flowRelatedRequestCompleted());
        dispatch(treeRequestCompleted());
        dispatch(ToggleIsLayoutTreeLoading(false));

        if (data.fields) {
            if (forceReload) {
                dispatch(clearLoadedFolders());
                dispatch(loadFields(data.fields, 0));
            } else {
                dispatch(loadOrMergeFields(data.fields, 0));
            }

            const updatedState = getState();
            dispatch(cacheFieldsForMode(updatedState.fields, true));

            if (useFieldTreeTabs) {
                dispatch(setTreeTabs(data.fieldsExperian, data.fieldsMarketplace, data.fieldsMyData, data.fieldsOther));
            }
            if (data.enabledFieldLabels) {
                dispatch(loadEnabledFieldLabels(data.enabledFieldLabels));
            }
            if (data.enabledFieldLabels3) {
                dispatch(loadEnabledFieldLabels3(data.enabledFieldLabels3));
            }
            if (data.enabledFieldVisibilityTypes) {
                dispatch(loadEnabledFieldVisibilityTypes(data.enabledFieldVisibilityTypes));
            }
            if (data.visibleFieldByCompanyUsers) {
                dispatch(loadVisibilityByCompanyUsers(data.visibleFieldByCompanyUsers));
            }
            if (data.fieldRates) {
                dispatch(loadFieldRates(data.fieldRates));
            }
            if (data.taxmanFieldRates) {
                dispatch(loadTaxmanFieldRates(data.taxmanFieldRates));
            }
            // IMPORTANT: Mark root as loaded
            dispatch(markFolderAsLoaded("#"));
        } else {
            throw new Error("Couldn't load fields.");
        }

        // Dispatch metadata from TreeDetails (mirrors what requestFieldTree does, without fields)
        if (details.enabledFieldLabels) {
            dispatch(loadEnabledFieldLabels(details.enabledFieldLabels));
        }
        if (details.enabledFieldLabels3) {
            dispatch(loadEnabledFieldLabels3(details.enabledFieldLabels3));
        }
        if (details.enabledFieldVisibilityTypes) {
            dispatch(loadEnabledFieldVisibilityTypes(details.enabledFieldVisibilityTypes));
        }
        if (details.visibleFieldByCompanyUser) {
            dispatch(loadVisibilityByCompanyUsers(details.visibleFieldByCompanyUser));
        }
        if (details.fieldRates) {
            dispatch(loadFieldRates(details.fieldRates));
        }
        if (details.taxmanFieldRates) {
            dispatch(loadTaxmanFieldRates(details.taxmanFieldRates));
        }
        if (details.checksum) {
            dispatch(setVarPersist("fieldsChecksum", details.checksum));
        }
    } catch (error) {
        dispatch(decAjaxCount());
        dispatch(flowRelatedRequestCompleted());
        dispatch(treeRequestCompleted());
        dispatch(ToggleIsLayoutTreeLoading(false));
        h.error("Error loading lazy admin field tree.", error);
    } finally {
        dispatch(toggleIsFieldTreeLoading(false));
    }
};
top.RDX.requestLazyFieldTreeAdmin = () => top.store.dispatch(requestLazyFieldTreeAdmin());

export const requestLazyChildFieldsAdmin = (folderId, onComplete) => async (dispatch, getState) => {
    const state = getState();

    // Check if already loaded
    const loadedFolders = state.vars?.loadedFolders || {};
    const byParent = state.fields?.byParent || {};
    const existingChildren = byParent[folderId];
    if (loadedFolders[folderId] && existingChildren && existingChildren.length > 0) {
        return;
    }

    // SET LOADING STATE BEFORE REQUEST
    dispatch(setFolderLoading(folderId, true));

    const url = `/Tree/children/${folderId}?editFields=1`;

    dispatch(incAjaxCount());

    try {
        const response = await request(url, { credentials: "same-origin" }, dispatch);
        const data = await h.toJson(await h.checkStatus(response));

        dispatch(decAjaxCount());

        if (data.fields) {
            // Merge the new children into existing fields
            dispatch(mergeChildFields(data.fields, folderId));
            
            // Mark folder as loaded
            dispatch(markFolderAsLoaded(folderId));
            
            // CLEAR LOADING STATE AFTER SUCCESS
            dispatch(setFolderLoading(folderId, false));

            const updatedState = getState();
            dispatch(cacheFieldsForMode(updatedState.fields, true));

            // Call the callback if provided
            if (onComplete) {
                onComplete();
            }
        } else {
            throw new Error("Couldn't load child fields.");
        }
    } catch (error) {
        dispatch(decAjaxCount());
        dispatch(setFolderLoading(folderId, false));        
        h.error("Error loading lazy admin child fields.", error);
    }
};
top.RDX.requestLazyChildFieldsAdmin = (folderId) => top.store.dispatch(requestLazyChildFieldsAdmin(folderId));


export const requestFieldTreeIfNeeded = () => (dispatch, getState) => {
    const state = getState();
    if (state.fields == null || state.fields.byId == null || Object.keys(state.fields.byId).length == 0) {
        dispatch(requestFieldTreeForLastTablekeyUsed());
    }
};
export const loadScriptObjects = (objects: Array<IScriptObject>): ILoadScriptObjects => ({
    type: "LOAD_SCRIPT_OBJECTS",
    objects,
});
top.RDX.loadScriptObjects = objects => top.store.dispatch(loadScriptObjects(objects));

export const loadUIDBScriptObjects = (objects: Array<IScriptObject>): ILoadUIDBScriptObjects => ({
    type: "LOAD_UIDB_SCRIPT_OBJECTS",
    objects,
});
top.RDX.loadUIDBScriptObjects = objects => top.store.dispatch(loadUIDBScriptObjects(objects));

export const setSearchFields = (matchedFields, tableKey = 0) => dispatch => {
    dispatch({
        type: "SET_SEARCH_FIELDS",
        matchedFields,
        tableKey,
    });
};
top.RDX.setSearchFields = (matchedFields, tableKey) => top.store.dispatch(setSearchFields(matchedFields, tableKey));

export const loadFields =
    (fields, tableKey = 0) =>
    dispatch => {
        dispatch({
            type: "LOAD_FIELDS",
            fields,
            tableKey,
        });
    };
top.RDX.loadFields = (fields, tableKey) => top.store.dispatch(loadFields(fields, tableKey));

export const loadOrMergeFields =
    (fields, tableKey = 0) =>
    (dispatch, getState) => {
        const byId = getState().fields.byId;
        if (!byId || Object.keys(byId).length === 0) {
            dispatch({ type: "LOAD_FIELDS", fields, tableKey });
        } else {
            dispatch({ type: "MERGE_CHILD_FIELDS", childFields: fields});
        }
    };
top.RDX.loadOrMergeFields = (fields, tableKey) => top.store.dispatch(loadOrMergeFields(fields, tableKey));

export const setTreeTabs =
    (fieldsExperian, fieldsMarketplace, fieldsMyData, fieldsOther = false) =>
    dispatch => {
        dispatch({
            type: "SET_FIELD_TAB_PERMISSIONS",
            fieldsExperian,
            fieldsMarketplace,
            fieldsMyData,
            fieldsOther,
        });
    };
top.RDX.setTreeTabs = (fieldsExperian, fieldsMarketplace, fieldsMyData, fieldsOther) =>
    top.store.dispatch(setTreeTabs(fieldsExperian, fieldsMarketplace, fieldsMyData, fieldsOther));

export const requestReportFieldTree = () => dispatch => {
    dispatch(ToggleIsLayoutTreeLoading(true));
    const url = "/Tree/ReportCombined";
    return fetch(url, { credentials: "same-origin" })
        .then(h.checkStatus)
        .then(h.toJson)
        .then(data => {
            dispatch(ToggleIsLayoutTreeLoading(false));

            if (data.fields) {
                dispatch(loadReportFields(data.fields));
            } else {
                throw new Error("Couldn't report load fields.");
            }
            if (data.checksum) {
                dispatch(setVar("reportFieldsChecksum", data.checksum));
            } else {
                throw new Error("Couldn't load report fields checksum.");
            }
            if (data.enabledFieldVisibilityTypes) {
                dispatch(loadEnabledFieldVisibilityTypes(data.enabledFieldVisibilityTypes));
            }
            if (data.fieldRates) {
                dispatch(loadFieldRates(data.fieldRates));
            }
            if (data.taxmanFieldRates) {
                dispatch(loadTaxmanFieldRates(data.taxmanFieldRates));
            }
        })
        .catch(error => {
            dispatch(ToggleIsLayoutTreeLoading(false));
            h.error("Error loading report field tree.", error);
        });
};
top.RDX.requestReportFieldTree = () => top.store.dispatch(requestReportFieldTree());

export const requestLayoutFieldTree =
    () =>
    dispatch => {
        dispatch(ToggleIsLayoutTreeLoading(true));
        const url = `/Tree/LayoutCombined?editFields=0&experianOnly=0`;
        return (
            fetch(url, { credentials: "same-origin" })
                /* eslint-disable no-console */
                .then(h.checkStatus)
                .then(
                    console.log(
                        "LayoutCombinededitFields=0&experianOnly=0:checkStatus" +
                            Date().toLocaleString() +
                            ""
                    )
                )
                .then(h.toJson)
                .then(
                    console.log(
                        "LayoutCombinededitFields=0&experianOnly=0:toJson" + Date().toLocaleString() + ""
                    )
                )
                .then(data => {
                    dispatch(ToggleIsLayoutTreeLoading(false));

                    if (data.fields) {
                        dispatch(loadLayoutFields(data.fields));
                    } else {
                        throw new Error("Couldn't layout load fields.");
                    }
                    if (data.checksum) {
                        dispatch(setVar("layoutFieldsChecksum", data.checksum));
                    } else {
                        throw new Error("Couldn't load layout fields checksum.");
                    }
                    if (data.enabledFieldVisibilityTypes) {
                        dispatch(loadEnabledFieldVisibilityTypes(data.enabledFieldVisibilityTypes));
                    }
                    if (data.fieldRates) {
                        dispatch(loadFieldRates(data.fieldRates));
                    }
                    if (data.taxmanFieldRates) {
                        dispatch(loadTaxmanFieldRates(data.taxmanFieldRates));
                    }
                })
                .catch(error => {
                    dispatch(ToggleIsLayoutTreeLoading(false));
                    h.error("Error loading layout field tree.", error);
                })
        );
    };
top.RDX.requestLayoutFieldTree = () => top.store.dispatch(requestLayoutFieldTree());

export const requestLayoutExperianFieldTree = () => dispatch => {
    dispatch(ToggleIsLayoutTreeLoading(true));
    const url = "/Tree/LayoutCombined?editFields=0&experianOnly=1";
    return (
        fetch(url, { credentials: "same-origin" })
            /* eslint-disable no-console */
            .then(h.checkStatus)
            .then(console.log("LayoutCombinededitFields=0&experianOnly=1:checkStatus" + Date().toLocaleString() + ""))
            .then(h.toJson)
            .then(console.log("LayoutCombinededitFields=0&experianOnly=1:toJson" + Date().toLocaleString() + ""))
            .then(data => {
                dispatch(ToggleIsLayoutTreeLoading(false));

                if (data.fields) {
                    dispatch(loadLayoutFields(data.fields));
                } else {
                    throw new Error("Couldn't load Experian layout fields.");
                }
                if (data.checksum) {
                    dispatch(setVar("layoutFieldsChecksum", data.checksum));
                } else {
                    throw new Error("Couldn't load Experian layout fields checksum.");
                }
                if (data.fieldRates) {
                    dispatch(loadFieldRates(data.fieldRates));
                }
                if (data.taxmanFieldRates) {
                    dispatch(loadTaxmanFieldRates(data.taxmanFieldRates));
                }
            })
            .catch(error => {
                dispatch(ToggleIsLayoutTreeLoading(false));
                h.error("Error loading Experian layout field tree.", error);
            })
    );
};
top.RDX.requestLayoutExperianFieldTree = () => top.store.dispatch(requestLayoutExperianFieldTree());

export const requestFullFieldTree = () => dispatch => {
    dispatch(ToggleIsLayoutTreeLoading(true));
    const url = "/Tree/FullFieldTree";
    return fetch(url, { credentials: "same-origin" })
        .then(h.checkStatus)
        .then(h.toJson)
        .then(data => {
            dispatch(ToggleIsLayoutTreeLoading(false));
            if (data) {
                dispatch(loadFields(data, 0));
            } else {
                throw new Error("Couldn't load full field tree.");
            }
        })
        .catch(error => {
            dispatch(ToggleIsLayoutTreeLoading(false));
            h.error("Error loading full field tree.", error);
        });
};
top.RDX.requestFullFieldTree = () => top.store.dispatch(requestFullFieldTree());

export const loadLayoutFields = layoutfields => ({
    type: "LOAD_LAYOUT_FIELDS",
    layoutfields,
});
top.RDX.loadLayoutFields = reportFields => top.store.dispatch(loadLayoutFields(reportFields));

export const loadReportFields = reportFields => ({
    type: "LOAD_REPORT_FIELDS",
    reportFields,
});
top.RDX.loadReportFields = reportFields => top.store.dispatch(loadReportFields(reportFields));

export const copytoClip = fieldKey => (dispatch, getState) => {
    const state = getState();
    if (!state.fields || !state.fields.byId) {
        console.warn("copytoClip:  Fields aren't loaded."); // eslint-disable-line no-console
        return;
    }
    let copytxt = state.fields.byId[fieldKey].text;
    if (state.fields.byId[fieldKey].leaf_description != null) {
        copytxt += " - " + state.fields.byId[fieldKey].leaf_description;
    }
    copy(copytxt);
};

// QueryBuilder specific - add a selected value to the "fieldData" from the fieldtree
const addSelectedValuesToFieldData = (fieldData: string, selectedValues: any) => {
    if (selectedValues == null) {
        return fieldData;
    }
    const parsedData = JSON.parse(fieldData.replace(/'/g, '"'));
    const selected = { value: selectedValues };
    return JSON.stringify({ rules: [Object.assign(parsedData.rules[0], selected)] });
};

/*
field example:
companyid : 0
created_dt : "2017-01-18T09:36:39.413"
data : "{'rules':[{'id':'10079','operator':'in'}]}"
detail_description : null
fieldkey : 10079
id : 10079
isLeaf : true
leaf_description : "Likelihood to purchase a new vehicle"
parent : "14"
sort : 5
sourcekey : 23
text : "New Vehicle (A300)"
type : "detail"
viewid : 4
*/

export const setSelectedField = fieldKey => ({
    type: "SET_SELECTED_FIELD",
    fieldKey,
});
export const clearSelectedField = () => ({
    type: "CLEAR_SELECTED_FIELD",
});
export const setSelectedFields = fieldKey => ({
    type: "SET_SELECTED_FIELDS",
    fieldKey,
});
export const clearSelectedFields = () => ({
    type: "CLEAR_SELECTED_FIELDS",
});
export const setEditFolder = isEditFolder => ({
    type: SET_PROPERTY,
    property: AdminDesignerProperties.isEditFolder,
    newValue: isEditFolder,
});

export const setAddField = isAddField => ({
    type: SET_PROPERTY,
    property: AdminDesignerProperties.isAddField,
    newValue: isAddField,
});
export const addTempField = field => ({
    type: "ADD_TEMP_FIELD",
    field,
});

// ========================================================
const _filtersLastLoadedByCompany = {};
import { dateDiffMinutes, incAjaxCount, decAjaxCount } from "./actionCreators";

export const requestFilterTree =
    (force: boolean = false) =>
    (dispatch, getState) => {
        const companyId = getState().session.companyId;
        if (
            !force &&
            _filtersLastLoadedByCompany[companyId] != null &&
            dateDiffMinutes(_filtersLastLoadedByCompany[companyId], new Date()) < 30
        ) {
            return;
        }

        const url = "/Tree/Filters";
        return fetch(url, { credentials: "same-origin" })
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                if (data.filters) {
                    dispatch(loadFilters(data.filters));
                    _filtersLastLoadedByCompany[companyId] = new Date();
                } else {
                    throw new Error("Couldn't load filters.");
                }
                if (data.checksum) {
                    dispatch(setVarPersist("filtersChecksum", data.checksum));
                } else {
                    throw new Error("Couldn't load filters checksum.");
                }
            })
            .catch(error => {
                h.error("Error loading filters.", error);
            });
    };
top.RDX.requestFilterTree = (force = false) => top.store.dispatch(requestFilterTree(force));

export const loadFilters = filters => ({
    type: "LOAD_FILTERS",
    filters,
});
top.RDX.loadFilters = filters => top.store.dispatch(loadFilters(filters));

export const requestNewFieldFolder =
    (parentId, folderName = "New Folder") =>
    dispatch => {
        if (!parentId) {
            return;
        }

        // Update database
        const url = `/Field/CreateNewFieldFolder?parentId=${parentId}&folderName=${folderName}`;
        dispatch(incAjaxCount());
        return (
            fetch(url, {
                credentials: "same-origin",
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
            })
                /* eslint-disable no-console */
                .then(h.checkStatus)
                .then(console.log("CreateNewFieldFolder:checkStatus" + Date().toLocaleString() + ""))
                .then(h.toJson)
                .then(console.log("CreateNewFieldFolder:toJson" + Date().toLocaleString() + ""))
                .then(data => {
                    dispatch(decAjaxCount());
                    if (data.folderId > 0) {
                        // Reload Fields
                        dispatch(requestEditFieldTree());
                        dispatch(requestEditLayoutFieldTree());
                        // set the new folder to renaming state
                        dispatch(startRenamingFieldFolder(data.folderId));
                    } else {
                        h.error("Error creating new folder.");
                    }
                })
                .catch(error => {
                    h.error("Error creating new folder.", error);
                })
        );
    };
top.RDX.requestNewFieldFolder = (parentId, folderName) =>
    top.store.dispatch(requestNewFieldFolder(parentId, folderName));

export const requestRenameFieldFolder = (folderId, newFolderName) => dispatch => {
    if (!folderId || !newFolderName || newFolderName == "") {
        return;
    }

    // Update database
    const url = `/Field/RenameFieldFolder?folderId=${folderId}&newFolderName=${newFolderName}`;
    dispatch(incAjaxCount());
    return (
        fetch(url, {
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
        })
            /* eslint-disable no-console */
            .then(h.checkStatus)
            .then(console.log("RenameFieldFolder:checkStatus" + Date().toLocaleString() + ""))
            .then(h.toJson)
            .then(console.log("RenameFieldFolder:toJson" + Date().toLocaleString() + ""))
            .then(data => {
                dispatch(decAjaxCount());
                if (data.success) {
                    // Update state
                    dispatch(renameFieldFolder(folderId, newFolderName));
                    // clear renaming state
                    dispatch(stopRenamingFieldFolder(folderId));
                } else {
                    h.error("Error renaming folder.");
                }
            })
            .catch(error => {
                h.error("Error renaming folder.", error);
                dispatch(decAjaxCount());
            })
    );
};
top.RDX.requestRenameFieldFolder = (folderId, newFolderName) =>
    top.store.dispatch(requestRenameFieldFolder(folderId, newFolderName));

export const requestDeleteFieldFolder = folderId => dispatch => {
    if (!folderId) {
        return;
    }

    // Update database
    const url = `/Field/DeleteFieldFolder?folderId=${folderId}`;
    dispatch(incAjaxCount());
    return (
        fetch(url, {
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
        })
            /* eslint-disable no-console */
            .then(h.checkStatus)
            .then(console.log("DeleteFieldFolder:checkStatus" + Date().toLocaleString() + ""))
            .then(h.toJson)
            .then(console.log("DeleteFieldFolder:toJson" + Date().toLocaleString() + ""))
            .then(data => {
                dispatch(decAjaxCount());
                if (data.success) {
                    // Update state
                    //dispatch(deleteFieldFolder(folderId));
                    // Reload tree
                    dispatch(requestEditFieldTree());
                    dispatch(requestEditLayoutFieldTree());
                } else {
                    h.error("Error deleting folder.");
                }
            })
            .catch(error => {
                h.error("Error deleting folder.", error);
                dispatch(decAjaxCount());
            })
    );
};
top.RDX.requestDeleteFieldFolder = folderId => top.store.dispatch(requestDeleteFieldFolder(folderId));

export const requestMoveFieldToFolder = (fieldId, newFolderId) => dispatch => {
    if (!fieldId || !newFolderId) {
        return;
    }

    // Update database
    const url = `/Field/UpdateFieldParentFolder?fieldId=${fieldId}&newFolderId=${newFolderId}`;
    dispatch(incAjaxCount());
    return fetch(url, {
        credentials: "same-origin",
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
    })
        .then(h.checkStatus)
        .then(h.toJson)
        .then(data => {
            dispatch(decAjaxCount());
            if (data.success) {
                dispatch(requestEditFieldTree());
                dispatch(requestEditLayoutFieldTree());
                // Update state
                dispatch(moveFieldToFolder(fieldId, newFolderId));
            } else {
                h.error(data.message || "Error moving field.");
            }
        })
        .catch(error => {
            h.error("Error moving field.", error);
        });
};
top.RDX.requestMoveFieldToFolder = (fieldId, newFolderId) =>
    top.store.dispatch(requestMoveFieldToFolder(fieldId, newFolderId));

export const requestMoveFieldsToFolder = (selectedFields, newFolderId) => dispatch => {
    if (!selectedFields || selectedFields.length == 0 || !newFolderId) {
        return;
    }

    dispatch(incAjaxCount());
    return fetch(`/Field/UpdateFieldsParentFolder`, {
        credentials: "same-origin",
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify({ selectedFields, newFolderId }),
    })
        .then(h.checkStatus)
        .then(h.toJson)
        .then(data => {
            dispatch(decAjaxCount());
            if (data.success) {
                dispatch(requestEditFieldTree());
                dispatch(requestEditLayoutFieldTree());
                // Update state
                dispatch(moveFieldsToFolder(selectedFields, newFolderId));
            } else {
                h.error("Error moving fields.");
            }
        })
        .catch(error => {
            h.error("Error moving fields.", error);
        });
};
top.RDX.requestMoveFieldTsoFolder = (selectedFields, newFolderId) =>
    top.store.dispatch(requestMoveFieldsToFolder(selectedFields, newFolderId));

// In the UI, mark a folder as being renamed
export const startRenamingFieldFolder = folderId => ({
    type: "START_RENAMING_FIELD_FOLDER",
    folderId,
});

// Stop renaming folder
export const stopRenamingFieldFolder = folderId => ({
    type: "STOP_RENAMING_FIELD_FOLDER",
    folderId,
});

export const renameFieldFolder = (folderId, newFolderName) => ({
    type: "RENAME_FIELD_FOLDER",
    folderId,
    newFolderName,
});

export const moveFieldToFolder = (fieldId, newFolderId) => ({
    type: "MOVE_FIELD_TO_FOLDER",
    fieldId,
    newFolderId,
});

export const moveFieldsToFolder = (fieldIds, newFolderId) => ({
    type: "MOVE_FIELDS_TO_FOLDER",
    fieldIds,
    newFolderId,
});

export const deleteFieldFolder = folderId => ({
    type: "DELETE_FIELD_FOLDER",
    folderId,
});

// Add measure field that is an actual field
import { SET_PROPERTY, AdminDesignerProperties } from "../reducers/adminDesigner";

// BEGIN ===Generic QB Field To Add Queues===
// Puts the queue in "state.vars"
// Assumes there will only be one QueryBuilder on the screen at a time.
// Only used by FlowItemEdit currently.
export const genericQbClearFieldToAdd = fieldKey => ({
    type: "GENERIC_QB_CLEAR_FIELD",
    fieldKey,
});

export const genericQbAddField =
    (fieldKey, index, selectedValues, group = null) =>
    (dispatch, getState) => {
        const state = getState();
        if (!state.fields || !state.fields.byId) {
            console.warn("Fields aren't loaded."); // eslint-disable-line no-console
            return;
        }

        if (!state.fields.byId[fieldKey]) {
            /* eslint-disable no-console */
            console.warn(`I was told to add [${fieldKey}], but I can't find a field with that fieldKey.`);
            /* eslint-enable no-console */
            return;
        }

        let fieldData = state.fields.byId[fieldKey].data;
        fieldData = addSelectedValuesToFieldData(fieldData, selectedValues);

        dispatch({
            type: "GENERIC_QB_ADD_FIELD",
            fieldKey,
            fieldData,
            group,
            index,
        });
    };
export const genericQbAddFieldMulti =
    (selectedFields, index, selectedValues, group = null) =>
    (dispatch, getState) => {
        const state = getState();

        let fieldsWithKeyAndData = [];

        Array.prototype.forEach.call(selectedFields, field => {
            const fieldKey = parseInt(field);
            let data = state.fields.byId[fieldKey].data;
            const fieldData = addSelectedValuesToFieldData(data, selectedValues);
            fieldsWithKeyAndData.push({ fieldKey, fieldData });
        });

        dispatch({
            type: "GENERIC_QB_ADD_FIELD_MULTI",
            fieldsWithKeyAndData,
            group,
            index,
        });
    };
// END ===Generic QB Field To Add Queues===

//begin field-filters-on-demand

export const loadRequestedFilters = filters => ({
    type: "LOAD_REQUESTED_FILTERS",
    filters,
});

export const removeRequestedFilter = filterId => ({
    type: "REMOVE_REQUESTED_FILTER",
    filterId,
});

export const handleSetSearchedFields = (dispatch, matchedFields, tableKey) => {
    if (matchedFields) {
        dispatch(setSearchFields(matchedFields, tableKey));
    } else {
        throw new Error("Couldn't load fields.");
    }
};

export const requestFieldFilters = fieldIds => dispatch => {
    dispatch(incAjaxCount());
    fetch("/Tree/FiltersForFields", {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ fieldIds }),
        credentials: "same-origin",
    })
        /* eslint-disable no-console */
        .then(h.checkStatus)
        .then(console.log("FiltersForFields:checkStatus" + Date().toLocaleString() + ""))
        .then(h.toJson)
        .then(console.log("FiltersForFields:toJson" + Date().toLocaleString() + ""))
        .then(data => {
            dispatch(loadRequestedFilters(data.filters));
            dispatch(decAjaxCount());
        })
        .catch(error => {
            dispatch(decAjaxCount());
            h.error("Error loading filters", error);
        });
};
//end field-filters-on-demand

export const setPrevEditable = (value) => ({
    type: 'SET_PREV_EDITABLE',
    payload: value,
});


// Action types for field label search
export const SET_FIELD_LABEL_SEARCH_RESULTS = 'SET_FIELD_LABEL_SEARCH_RESULTS';
export const CLEAR_FIELD_LABEL_SEARCH_RESULTS = 'CLEAR_FIELD_LABEL_SEARCH_RESULTS';
export const SET_UMBRELLA_LABEL_SEARCH_RESULTS = 'SET_UMBRELLA_LABEL_SEARCH_RESULTS';
export const CLEAR_UMBRELLA_LABEL_SEARCH_RESULTS = 'CLEAR_UMBRELLA_LABEL_SEARCH_RESULTS';

/**
 * Action to set field label search results in Redux
 * Populates state.vars.fieldLabelSearchResults with matching fields and ancestors
 */
export const setFieldLabelSearchResults = (searchResults, searchResultsByParent) => ({
    type: SET_FIELD_LABEL_SEARCH_RESULTS,
    searchResults,      // { workid: field } - matching fields
    searchResultsByParent, // { parentId: [childIds] } - for tree structure
});

/**
 * Action to clear field label search results
 */
export const clearFieldLabelSearchResults = () => ({
    type: CLEAR_FIELD_LABEL_SEARCH_RESULTS,
});

/**
 * Action to set umbrella label search results in Redux
 */
export const setUmbrellaLabelSearchResults = (searchResults, searchResultsByParent) => ({
    type: SET_UMBRELLA_LABEL_SEARCH_RESULTS,
    searchResults,      // { workid: field } - matching fields
    searchResultsByParent, // { parentId: [childIds] } - for tree structure
});

/**
 * Action to clear umbrella label search results
 */
export const clearUmbrellaLabelSearchResults = () => ({
    type: CLEAR_UMBRELLA_LABEL_SEARCH_RESULTS,
});

/**
 * Optimized version: Batches ancestor requests and uses ParentIds from field data
 * to avoid multiple API calls
 */
export const performFieldLabelSearch = (selectedFieldLabelIds) => async (dispatch, getState) => {
    const state = getState();

    // If no labels selected, clear search
    if (!selectedFieldLabelIds || selectedFieldLabelIds.length === 0) {
        dispatch(clearFieldLabelSearchResults());
        return;
    }

    const enabledFieldLabels = state.fieldsByCompany.enabledFieldLabels || {};
    const fields = state.fields;

    if (!fields || !fields.byFolder) {
        console.warn('Fields not loaded yet');
        return;
    }

    // --------------------------------------------------
    // Find all workids that have any of the selected labels
    // --------------------------------------------------
    const matchingWorkIds = [];
    Object.keys(enabledFieldLabels).forEach(workidStr => {
        const workid = parseInt(workidStr, 10);
        const fieldLabelIds = enabledFieldLabels[workid] || [];

        const hasMatchingLabel = selectedFieldLabelIds.some(selectedId =>
            fieldLabelIds.includes(selectedId)
        );

        if (hasMatchingLabel) {
            matchingWorkIds.push(workid);
        }
    });

    if (matchingWorkIds.length === 0) {
        dispatch(clearFieldLabelSearchResults());
        return;
    }

    const searchResults = {};
    const searchResultsByParent = {};
    const allRelevantWorkIds = new Set();

    // --------------------------------------------------
    // Load missing fields (NO await inside a loop)
    // --------------------------------------------------
    const loadFieldPromises = matchingWorkIds.map(workid => {
        if (searchResults[workid]) {
            return null;
        }

        const field = fields.byFolder[workid];

        if (field) {
            searchResults[workid] = field;
            allRelevantWorkIds.add(workid);
            return null;
        }

        return new Promise(resolve => {
            dispatch(
                requestFieldDetails(workid, fieldDetails => {
                    if (fieldDetails) {
                        searchResults[workid] = fieldDetails;
                        allRelevantWorkIds.add(workid);
                    }
                    resolve();
                })
            );
        });
    });

    await Promise.all(loadFieldPromises.filter(Boolean));

    // --------------------------------------------------
    // Fetch ancestors in batches (NO await inside a loop)
    // --------------------------------------------------
    const BATCH_SIZE = 10;
    const ancestorBatchPromises = [];

    for (let i = 0; i < matchingWorkIds.length; i += BATCH_SIZE) {
        const batch = matchingWorkIds.slice(i, i + BATCH_SIZE);

        ancestorBatchPromises.push(
            Promise.all(
                batch.map(workid =>
                    new Promise(resolve => {
                        dispatch(
                            requestFieldAncestors(workid, ancestors => {
                                resolve({ workid, ancestors: ancestors || [] });
                            })
                        );
                    })
                )
            )
        );
    }

    const allBatchResults = await Promise.all(ancestorBatchPromises);

    allBatchResults.flat().forEach(({ ancestors }) => {
        ancestors.forEach(ancestor => {
            if (!ancestor?.workid || searchResults[ancestor.workid]) return;

            // Use ancestor payload directly
            searchResults[ancestor.workid] = ancestor;
            allRelevantWorkIds.add(ancestor.workid);
        });
    });

    // --------------------------------------------------
    // Build parent -> children mapping
    // --------------------------------------------------
    allRelevantWorkIds.forEach(workid => {
        const field = searchResults[workid];

        if (field && field.parent) {
            const parentId = field.parent;

            if (!searchResultsByParent[parentId]) {
                searchResultsByParent[parentId] = [];
            }

            if (!searchResultsByParent[parentId].includes(workid)) {
                searchResultsByParent[parentId].push(workid);
            }
        }
    });

    // --------------------------------------------------
    // Root handling (must use searchResults)
    // --------------------------------------------------
    const rootFields = matchingWorkIds.filter(workid => {
        const field = searchResults[workid];
        return field && (field.parent === '#' || field.parent === '0' || !field.parent);
    });

    if (rootFields.length > 0) {
        searchResultsByParent['#'] = rootFields;
    }

    dispatch(setFieldLabelSearchResults(searchResults, searchResultsByParent));
};

/**
 * Performs a search for fields tagged with a specific umbrella label.
 * Builds a hierarchical tree structure including ancestors for proper tree navigation.
 */
export const performUmbrellaLabelSearch = (selectedUmbrellaLabelId) => async (dispatch, getState) => {
    const state = getState();

    if (!selectedUmbrellaLabelId || selectedUmbrellaLabelId.length === 0) {
        dispatch(clearUmbrellaLabelSearchResults());
        return;
    }

    const enabledFieldLabels3 = state.fieldsByCompany.enabledFieldLabels3 || {};
    const fields = state.fields;

    if (!fields || !fields.byFolder) {
        console.warn('Fields not loaded yet');
        return;
    }

    // Find all fields with the selected umbrella label
    const matchingWorkIds = [];
    const selectedIdAsNumber = parseInt(selectedUmbrellaLabelId, 10);
    
    Object.keys(enabledFieldLabels3).forEach(workidStr => {
        const workid = parseInt(workidStr, 10);
        const umbrellaIds = enabledFieldLabels3[workid] || [];

        if (umbrellaIds.includes(selectedIdAsNumber)) {
            matchingWorkIds.push(workid);
        }
    });

    if (matchingWorkIds.length === 0) {
        dispatch(clearUmbrellaLabelSearchResults());
        return;
    }

    // Initialize result containers
    const searchResults = {}; // { workid: field } - Full field objects
    const searchResultsByParent = {}; // { parentId: [childIds] } - Tree structure
    const allRelevantWorkIds = new Set(); // Track all workids to include

    // Load field details (cached or from API)
    const loadFieldPromises = matchingWorkIds.map(async (workid) => {
        if (searchResults[workid]) {
            return true;
        }

        const field = fields.byFolder[workid];
        if (field) {
            searchResults[workid] = field;
            allRelevantWorkIds.add(workid);
            return true;
        }

        // Fetch field details
        const fieldDetails = await dispatch(requestFieldDetails(workid));  //Now valid
    
        if (fieldDetails) {
            searchResults[workid] = fieldDetails;
            allRelevantWorkIds.add(workid);
            return true;
        }
    
        return false;
    });
    
    const results = await Promise.all(loadFieldPromises);
    const allSucceeded = results.every(result => result === true);

    if (!allSucceeded) { 
        // some fields fail to load due to visibilty
        dispatch(clearUmbrellaLabelSearchResults());
        return;
    }

    // Process ancestors in batches to avoid overwhelming the API
    const BATCH_SIZE = 10;
    const ancestorBatchPromises = [];
    for (let i = 0; i < matchingWorkIds.length; i += BATCH_SIZE) {
        const batch = matchingWorkIds.slice(i, i + BATCH_SIZE);
        ancestorBatchPromises.push(
            Promise.all(
                batch.map(workid =>
                    new Promise(resolve => {
                        dispatch(
                            requestFieldAncestors(workid, ancestors => {
                                resolve({ workid, ancestors: ancestors || [] });
                            })
                        );
                    })
                )
            )
        );
    }

    // Wait for all ancestor batches to complete
    const allBatchResults = await Promise.all(ancestorBatchPromises);
    
    // Process ancestor results and add to search results
    allBatchResults.flat().forEach(({ ancestors }) => {
        ancestors.forEach(ancestor => {
            // Skip if ancestor is missing or already processed
            if (!ancestor?.workid || searchResults[ancestor.workid]) return;

            searchResults[ancestor.workid] = ancestor;
            allRelevantWorkIds.add(ancestor.workid);
        });
    });

    // Build parent-child mapping for tree structure
    allRelevantWorkIds.forEach(workid => {
        const field = searchResults[workid];
        if (field && field.parent) {
            const parentId = field.parent;

            if (!searchResultsByParent[parentId]) {
                searchResultsByParent[parentId] = [];
            }

            if (!searchResultsByParent[parentId].includes(workid)) {
                searchResultsByParent[parentId].push(workid);
            }
        }
    });

    // Identify fields that should appear at the root of the tree
    const rootFields = matchingWorkIds.filter(workid => {
        const field = fields.byFolder[workid];
        return field && (field.parent === '#' || field.parent === '0' || !field.parent);
    });

    // Add root fields to special '#' parent key
    if (rootFields.length > 0) {
        searchResultsByParent['#'] = rootFields;
    }

    dispatch(setUmbrellaLabelSearchResults(searchResults, searchResultsByParent));
};
// Expose to global for debugging
top.RDX.performFieldLabelSearch = (selectedFieldLabelIds) => 
    top.store.dispatch(performFieldLabelSearch(selectedFieldLabelIds));
top.RDX.performUmbrellaLabelSearch = (selectedUmbrellaLabelId) => 
    top.store.dispatch(performUmbrellaLabelSearch(selectedUmbrellaLabelId));
top.RDX.clearFieldLabelSearchResults = () => 
    top.store.dispatch(clearFieldLabelSearchResults());
top.RDX.clearUmbrellaLabelSearchResults = () => 
    top.store.dispatch(clearUmbrellaLabelSearchResults());

